<app-modal-window title="Payout lock settings"
                  [actions]="true"
                  [disabledConfirm]="!payoutLockForm.valid"
                  (confirm)="onSubmit()"
                  (close)="close()">
  <form [formGroup]="payoutLockForm" (ngSubmit)="onSubmit()">


    <div class="input-container">


      <mat-form-field appearance="outline" class="field">
        <mat-label>Lock</mat-label>
        <mat-select formControlName="isLock" panelClass="recent-operation-select-panel"
                    placeholder="lock">
          <div class="mat-select-list">
            <mat-option *ngFor="let item of [true, false]" [value]="item">{{ item ? 'Yes' : 'No' }}</mat-option>
          </div>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="field" appearance="outline">
        <mat-label>End At:</mat-label>
        <input matInput [matDatepicker]="dp" formControlName="endAt">
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Available payout sum</mat-label>
        <input matInput type="number" id="amount" formControlName="availablePayoutSum">
        <span class="visual-usd">{{this.payoutLockForm.get('availablePayoutSum')?.value / 100 | currency : 'USD'}}</span>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Unlock payment sum</mat-label>
        <input matInput type="number"  formControlName="unlockPaymentSum">
        <span class="visual-usd">{{this.payoutLockForm.get('unlockPaymentSum')?.value / 100 | currency : 'USD'}}</span>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Reason</mat-label>
        <input matInput type="text" formControlName="lockReason">
      </mat-form-field>
    </div>


  </form>
</app-modal-window>
